<template>
  <fragment>
    <div class="col-12 col-lg-6">
      <custom-user-tags-section
        v-if="customUserTags.hasTags()"
        :value="registrationsReport.parameters.customCampusTags"
        @input="setCustomTags"
      />
      <div class="dash-section">
        <div class="header mb-4">
          <div>
            <h2 id="studentsListTitle" class="title">
              {{ totalStudents }} Registered Users
            </h2>

            <p class="body full-width mb-2">
              Find registered users and adjust credits.
            </p>
          </div>
          <div class="actions section-header-offset">
            <button
              v-if="canBulkUpload"
              class="dash-button"
              @click="handleUpload"
            >
              Bulk Upload Allowances
            </button>
            <button class="dash-button" @click="handleInvite()">Invite</button>
          </div>
        </div>
        <div class="dash-sub-section mt-0">
          <edit-student-allowance
            :school-id="schoolId"
            @invite="handleInvite"
          />
        </div>
      </div>
      <registrations-over-time-section />
    </div>
    <div class="col-12 col-lg-6">
      <mental-health-concerns-section />
      <demographics-section />
    </div>
  </fragment>
</template>

<script>
import DemographicsSection from './Students/DemographicsSection.vue';
import MentalHealthConcernsSection from './Students/MentalHealthConcernsSection.vue';
import RegistrationsOverTimeSection from './Students/RegistrationsOverTimeSection.vue';
import EditStudentAllowance from '../Credits/EditStudentAllowance.vue';
import InviteStudentModal from './Students/InviteStudentModal.vue';
import CustomUserTagsSection from './Students/CustomUserTagsSection.vue';
import UploadAllowances from './Students/UploadAllowances/UploadAllowances.vue'

export default {
  name: 'StudentsTabAnonymized',

  components: {
    DemographicsSection,
    MentalHealthConcernsSection,
    RegistrationsOverTimeSection,
    EditStudentAllowance,
    CustomUserTagsSection,
  },

  inject: ['studentDetailsReport','registrationsReport','demographicsReport','customUserTags'],

  data() {
    return {
      canBulkUpload: false,
    }
  },

  computed: {
    totalStudents() {
      return this.studentDetailsReport.data.activeStudents;
    },
    schoolId() {
      return this.studentDetailsReport.schoolId;
    },
  },

  async mounted() {
    this.canBulkUpload = this.$store.getters.currentUser.isAdmin
      || await this.$globals.hasFeature('can-bulk-upload');
  },

  methods: {
    handleInvite(studentEmail) {
      this.$modal.show(InviteStudentModal, {
        props: { initialEmail: studentEmail }
      });
    },
    handleUpload() {
      this.$modal.show(UploadAllowances, {
        props: {
          schoolId: this.studentDetailsReport.schoolId
        }
      })
    },
    setCustomTags(tagsList) {
      this.registrationsReport.setParameters({ customCampusTags: tagsList });
      this.demographicsReport.withCustomTags(tagsList);
    }
  }
};
</script>

<style lang="scss" scoped>
.dash-section {
  min-height: 0px;
}

.dash-sub-section {
  border-top: none;
}
</style>
